import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

/**
 * Shows the element's title as a tooltip, but only when its text is
 * actually truncated (text-truncate + max-width) — e.g. long view names
 * in the beta tasks tab row. Untruncated elements lose the title so no
 * redundant native tooltip appears.
 */
export default class extends Controller {
  connect() {
    if (this.element.scrollWidth > this.element.clientWidth) {
      this.tooltip = new bootstrap.Tooltip(this.element, {
        placement: this.element.dataset.placement || 'bottom',
        title: this.element.title,
        trigger: 'hover',
        container: 'body'
      })
    } else {
      this.element.removeAttribute('title')
    }
  }

  disconnect() {
    try {
      this.tooltip?.dispose()
    } catch {
      // Bootstrap throws when a tooltip is disposed mid-hide-transition
      // (e.g. a Turbo refresh right after dragging the tab) — safe to ignore
    }
    this.tooltip = null
  }
}
